define(["exports", "react"], function (_exports, _react) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ContentCheck = void 0;
  _react = _interopRequireWildcard(_react);

  var ContentCheck = function ContentCheck(_ref) {
    var children = _ref.children,
        check = _ref.check;
    return check ? /*#__PURE__*/_react.default.createElement(_react.Fragment, null, children) : null;
  };

  _exports.ContentCheck = ContentCheck;
});